import { render, staticRenderFns } from "./eduKakaoSync.vue?vue&type=template&id=f8213f0e&"
import script from "./eduKakaoSync.vue?vue&type=script&lang=js&"
export * from "./eduKakaoSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports